import React, { createContext, useContext, useEffect, useState } from "react";
import CartService from "services/cart";
import { Toaster, toaster } from "@/components/ui/toaster"
import { Button, CloseButton, Container, Dialog, Portal } from "@chakra-ui/react"
import { useStore } from "contexts/store"
import { useLocation } from "react-router-dom";
const AppContext = createContext(null);
const service = new CartService();

export const AppProvider = ({ children }) => {
    const { store } = useStore();
    const [showProductSearch, setShowProductSearch] = useState(false);
    const [productSearchList, setProductSearchList] = useState([]);
    const [pageTitle, setPageTitle] = useState(store.web.title);
    const [processing, setProcessing] = useState(false);
    const [openAddToCart, setOpenAddToCart] = useState(null);
    const [addToCartProductID, setAddToCartProductID] = useState(null);
    const [addToCartVariantID, setAddToCartVariantID] = useState(null);
    const [showMenu, setShowMenu] = useState(false);
    const [confirmBox, setConfirmBox] = useState({});
    const location = useLocation();

    useEffect(() => {

        setShowMenu(false);

    }, [location]);


    const showAddToCart = (product_id, variant_id) => {
        setOpenAddToCart(true);
        setAddToCartProductID(product_id);
        setAddToCartVariantID(variant_id);
    }
    const showToast = (toast) => {
        if (typeof toast == "string") {
            toaster.create({
                description: toast,
                type: "info",
            })

        } else {
            toaster.create(toast);
        }

    }

    const showConfirm = ({ title, message, onOk, onCancel }) => {
        var newData = { title, message, onOk, onCancel, show: true };
        setConfirmBox(newData);
    }

    const onBtnOkClick = () => {
        if (confirmBox.onOk) {
            confirmBox.onOk();
        }
        setConfirmBox({ show: false })

    }
    useEffect(() => {

    }, [])

    const copyText = (text) => {
        navigator.clipboard.writeText(text);
        showToast("Đã copy")
    }

    const printPdf = (url) => {
        window.location = url;
        // var iframe = document.createElement('iframe');


        // fetch(url)
        //     .then((response) => response.blob())
        //     .then((blob) => {
        //         const objectURL = URL.createObjectURL(blob);


        //         var childNode = document.body.appendChild(iframe);

        //         iframe.style.display = 'none';
        //         iframe.onload = function () {
        //             setTimeout(function () {
        //                 iframe.focus();
        //                 iframe.contentWindow.print();
        //                 // setTimeout(() => {
        //                 //     document.body.removeChild(childNode);
        //                 // }, 5000)
        //             }, 1);
        //         };


        //         iframe.src = objectURL;

        //     });




    }



    return (
        <AppContext.Provider value={{ showProductSearch, setShowProductSearch, productSearchList, setProductSearchList, pageTitle, setPageTitle, processing, setProcessing, openAddToCart, setOpenAddToCart, showAddToCart, addToCartProductID, addToCartVariantID, showToast, showMenu, setShowMenu, showConfirm, printPdf, copyText }}>

            <Toaster />



            <Dialog.Root open={confirmBox.show} onOpenChange={(e) => setConfirmBox({ ...confirmBox, show: e.open })} size={"xs"}>

                <Portal>
                    <Dialog.Backdrop />
                    <Dialog.Positioner>
                        <Container maxW={"md"}>
                            <Dialog.Content>
                                <Dialog.Header>
                                    <Dialog.Title>{confirmBox.title}</Dialog.Title>
                                </Dialog.Header>
                                <Dialog.Body>
                                    <p>
                                        {confirmBox.message}
                                    </p>
                                </Dialog.Body>
                                <Dialog.Footer>
                                    <Dialog.ActionTrigger asChild>
                                        <Button variant="outline">Huỷ</Button>
                                    </Dialog.ActionTrigger>
                                    <Button onClick={onBtnOkClick}>OK</Button>
                                </Dialog.Footer>
                                <Dialog.CloseTrigger asChild>
                                    <CloseButton size="sm" />
                                </Dialog.CloseTrigger>
                            </Dialog.Content>
                        </Container>
                    </Dialog.Positioner>
                </Portal>
            </Dialog.Root>

            {children}
        </AppContext.Provider>
    );
};

export const useApp = () => {
    return useContext(AppContext);
}